import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'img'
})
export class ImageNotFoundDirective {
  @HostListener('error', ['$event.target'])
  onError(img) {
    if (img.currentSrc == "") {
      img.src = '/assets/images/custom/imageNotFound/noImage.png';
    }
    else {
      img.src = '/assets/images/custom/imageNotFound/imageNotFound.png';
    }
    img.removeAttribute('title');
    img.removeAttribute('alt');
  }
  constructor() {
   }

}
